import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Vendor } from '../models/vendor';
import { User } from '../models/user';
import { AddUsersDialogComponent } from '../../supplier/add-users-dialog/add-users-dialog.component';

@Component({
  selector: 'app-vendor-pill',
  templateUrl: './vendor-pill.component.html',
  styleUrls: ['./vendor-pill.component.scss'],
  standalone: false,
})
export class VendorPillComponent {
  @Input() vendor?: Vendor;

  @Input() showCount = true;

  @Output() userAdded = new EventEmitter<{ vendor: Vendor; user: User }>();
  @Output() usersChanged = new EventEmitter<{ vendor: Vendor; users: User[] }>();

  private readonly MAX_CHARS = 10;

  constructor(private dialog: MatDialog) {}

  get userCount(): number {
    if (!this.vendor) return 0;
    const asAny: any = this.vendor as any;
    if (Array.isArray(asAny.users)) return asAny.users.length;
    if (typeof asAny.connectedUsersCount === 'number') return asAny.connectedUsersCount;
    if (typeof asAny.userCount === 'number') return asAny.userCount;
    return 0;
  }

  get colorClass(): string {
    if (!this.vendor) return 'warn';
    if (this.userCount === 0) return 'warn';
    return 'ok';
  }

  get shortName(): string {
    const name = this.vendor?.name || 'Unnamed vendor';
    if (name.length <= this.MAX_CHARS) return name;
    return name.slice(0, this.MAX_CHARS - 1).trim() + '…';
  }

  openAddUser(): void {
    if (!this.vendor) return;
    const ref = this.dialog.open(AddUsersDialogComponent, {
      width: '720px',
      maxWidth: '95vw',
      data: { vendor: this.vendor },
    });

    ref.afterClosed().subscribe((updatedUsers: User[] | undefined) => {
      if (updatedUsers) {
        this.usersChanged.emit({ vendor: this.vendor!, users: updatedUsers });
      }
    });
  }
}
